import { FormConfigContext } from '@juvare/common-form-ui/FormConfigContext';
import React from 'react';
import { buildFilterConfig } from '../utils';
export function useFilterConfig(params, deps) {
    let callback;
    let valueProviders;
    if (typeof params === 'function') {
        callback = params;
        valueProviders = undefined;
    }
    else {
        callback = params.callback;
        valueProviders = params.valueProviders;
    }
    const formConfigContext = React.useContext(FormConfigContext);
    return React.useMemo(() => {
        return buildFilterConfig(callback, {
            valueProviders,
            formConfigContext,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [callback, formConfigContext, ...deps]);
}
